import { HIDE_TOAST, showToast } from "app/actions/toast_actions";
import { translate } from "app/filters/i18nFilter";
import { renderErrorToast } from "app/pages/sales-intelligence/common-components/ErrorToast/ErrorToast";
import { renderLoadingToast } from "app/pages/sales-intelligence/common-components/LoadingToast/LoadingToast";
import type { ThunkDispatchCommon } from "single-spa/store/types";

import { downloadPdf } from "./action-creators";

export const downloadPdfThunk = (messageId: string, pdfMethod: () => Promise<void>) => {
    return async (dispatch: ThunkDispatchCommon) => {
        const timestamp = Date.now();

        dispatch(downloadPdf.request({ messageId }));
        const loadingToast = renderLoadingToast({
            content: translate("si.pages.ai_agent.download_pdf.meeting.loading_toast"),
            hideCloseIcon: true,
        });
        dispatch(showToast(loadingToast, "success", timestamp));

        try {
            await pdfMethod();
            dispatch(downloadPdf.success({ messageId }));
        } catch (error) {
            dispatch(downloadPdf.failure({ messageId, error }));
            const timestampError = Date.now();
            const handleRetryDownload = () => {
                dispatch({
                    type: HIDE_TOAST,
                    toast: { timestamp: timestampError },
                });
                void dispatch(downloadPdfThunk(messageId, pdfMethod));
            };
            const errorToast = renderErrorToast({
                content: translate("si.pages.ai_agent.download_pdf.meeting.error_toast"),
                buttonText: translate("si.common.try_again"),
                onButtonClick: handleRetryDownload,
            });
            dispatch(showToast(errorToast, "error", timestampError));
        } finally {
            dispatch({
                type: HIDE_TOAST,
                toast: { timestamp },
            });
        }
    };
};
